import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './pages/About';
import Register from './pages/Register';
import Login from './pages/Login';
import Patient from './pages/Patient';
import Doctor from './pages/Doctor';
import Appointments from './pages/Appointments';
import MedicalLetters from './pages/MedicalLetters';
import PatientDocuments from './pages/PatientDocuments';
import ChangePassword from './pages/ChangePassword';
import GDPRConsent from './components/GDPRConsent';
import ConsentGuard from './components/ConsentGuard';
import Reviews from './pages/Reviews';
import Training from './pages/Training';
import VisitCardPage from './pages/visitcard';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentCancel from './pages/PaymentCancel';
import Financiar from './pages/Financiar';
import Plati from './pages/Plati';
import Donations from './pages/Donations';
import Statistics from './pages/Statistics';
import { useFbPixelPageView } from './hooks/useFbPixelPageView';
import MaintenancePage from './components/MaintenancePage';

// Read maintenance mode from environment variable
const MAINTENANCE_MODE = import.meta.env.VITE_MAINTENANCE_MODE === 'true';

// List of allowed paths during maintenance
const ALLOWED_PATHS = ['/login'];

function AppContent() {
  useFbPixelPageView();

  useEffect(() => {
    // console.log('App mounted'); // Removed debug log for cleaner console
  }, []);

  // If in maintenance mode and not on an allowed path, show maintenance page
  if (MAINTENANCE_MODE && !ALLOWED_PATHS.includes(window.location.pathname)) {
    return <MaintenancePage />;
  }

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <Header className="print:hidden" />
      <main className="flex-1 print:pt-0">
        <Routes>
          <Route path="/" element={<Hero />} />
          <Route path="/despre" element={<About />} />
          <Route path="/pacient" element={<Patient />} />
          <Route path="/doctor" element={<Doctor />} />
          <Route path="/doctor/appointments" element={<Appointments />} />
          <Route path="/doctor/medical-letters" element={<MedicalLetters />} />
          <Route path="/doctor/patient/:patientId/documents" element={<PatientDocuments />} />
          <Route path="/register" element={<Register />} />
          <Route path="/login" element={<Login />} />
          <Route path="/schimba-parola" element={<ChangePassword />} />
          <Route path="/recenzii" element={<Reviews />} />
          <Route path="/ghid-utilizare" element={<Training />} />
          <Route path="/visitcard" element={<VisitCardPage />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />
          <Route path="/payment-cancel" element={<PaymentCancel />} />
          <Route path="/financiar" element={<Financiar />} />
          <Route path="/plati" element={<Plati />} />
          <Route path="/donatii" element={<Donations />} />
          <Route path="/statistici" element={<Statistics />} />
          {/* Catch-all route */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <GDPRConsent />
      <ConsentGuard />
    </div>
  );
}

export default function App() {
  return (
    <Router future={{
      v7_startTransition: true,
      v7_relativeSplatPath: true
    }}>
      <AppContent />
    </Router>
  );
}
